/**
 * home health demo layer — the only import surface for the rest of the app.
 * Keep mounts in existing files to one line each so merge-down from main stays cheap.
 */
import { Route, Routes } from "react-router-dom";
import { PendingAdmissionsPage } from "./views/admissions/PendingAdmissionsPage";
import { ReferralsPage } from "./views/admissions/ReferralsPage";
import { CapacityPage } from "./views/capacity/CapacityPage";
import { MyWeekPage } from "./views/myWeek/MyWeekPage";

export { HomeHealthDemoAppBarButton } from "./HomeHealthDemoAppBarButton";
export { HomeHealthDemoRoot } from "./HomeHealthDemoRoot";
export { FreshOnReseed as HomeHealthFreshOnReseed } from "./components/FreshOnReseed";
export { HomeHealthPatientSection } from "./views/episode/HomeHealthPatientSection";
export { HomeHealthCalendarButton } from "./views/episode/HomeHealthCalendarButton";
export { useHomeHealthPatientNotes } from "./views/episode/useHomeHealthPatientNotes";
export { HomeHealthVisitConfirmation } from "./views/confirmation/VisitConfirmationSlot";
export { ComplianceTab as HomeHealthComplianceTab } from "./views/worklist/ComplianceTab";
export { useHomeHealthDemoEnabled } from "./useHomeHealthDemoEnabled";
export { HomeHealthPlannedVsActualWidget } from "./views/kpis/PlannedVsActualWidget";

/**
 * Mounted at `/my-week/*` in App.tsx. My day is a date under My week rather than
 * a menu entry of its own, so the browser's back button is the way back to the
 * week and the clinician still has exactly one screen in the menu. Since
 * 2026-09-19 the day opens as a panel **over** the week, so both URLs are the one
 * route and the one component: an optional `:date` keeps the week mounted behind
 * the panel instead of remounting it — and with it the week she had paged to.
 */
export function MyWeekRoutes() {
  return (
    <Routes>
      <Route path=":date?" element={<MyWeekPage />} />
    </Routes>
  );
}

/** Mounted at `/capacity/*` in App.tsx. */
export function CapacityRoutes() {
  return (
    <Routes>
      <Route index element={<CapacityPage />} />
      <Route path=":tab" element={<CapacityPage />} />
    </Routes>
  );
}

/**
 * Mounted at `/referrals/*` in App.tsx. Referrals and Pending admissions are two
 * menu items with two routes, not two tabs on one page: the person deciding a
 * referral and the person working a pending admission may be different people.
 */
export function ReferralsRoutes() {
  return (
    <Routes>
      <Route index element={<ReferralsPage />} />
      <Route path=":referralId" element={<ReferralsPage />} />
    </Routes>
  );
}

/** Mounted at `/pending-admissions/*` in App.tsx. */
export function PendingAdmissionsRoutes() {
  return (
    <Routes>
      <Route index element={<PendingAdmissionsPage />} />
    </Routes>
  );
}
